import React, {useContext, useEffect, useRef} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import {Form} from 'react-bootstrap'
import {IsAuthContext} from 'app/App'

const formatAddMarkValue = (value) => {
    if (value===null) return true
    return value === true || value === 1 || value === '1'
}

const AddMarkExportForm = (props) => {
    const t = useTranslate();
    const { authParam } = useContext(IsAuthContext);
    const { addMark, setAddMark } = props
    const initializedFromConfig = useRef(false);
    const manualChange = useRef(false);

    useEffect(function () {
        const advanceparams = authParam?.company?.advanceparams

        if (initializedFromConfig.current || manualChange.current || !advanceparams || Array.isArray(advanceparams) || !advanceparams.hasOwnProperty('add_mark_export')) return

        setAddMark(formatAddMarkValue(advanceparams['add_mark_export']))
        initializedFromConfig.current = true
    }, [])

    const handleChange = () => {
        manualChange.current = true
        setAddMark(!addMark)
    }

    return(
        <Form>
            <Form.Check
                type="checkbox"
                label={t('apostropheBeginningCell')}
                checked={addMark}
                onChange={handleChange}
            />
        </Form>
    )
}

export default AddMarkExportForm;
